var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallFollowNavigatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.987mm",
    height: "26.013mm",
    viewBox: "0 0 25.987 26.013",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.193 .28558)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.987 0.54985v24.384l17.904-0.03036v-6.1923l6.4958-0.01102-0.01613-18.192z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.52917 0.57052v24.384l17.904-0.03036v-6.1923l6.4958-0.01102-0.01613-18.192z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.4721 2.4869 2.9944 20.689 8.8101-20.696 8.7706 7.2442-10.013 7.0167",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5596
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.974 2.5952 20.452-0.034608 0.01355 14.202-6.5065 0.01608 0.01322 6.1973-13.971 0.02542v-15.142",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5401
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5875
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.446 0.57052v24.384l17.904-0.03036v-6.1923l6.4958-0.01102-0.01613-18.192z",
    fill: "#f9f9f9",
    stroke: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.256 2.2557 8.0361 18.727 3.9994-18.734 8.5891 7.3622 0.01479 7.1923-6.3956 0.01659 0.01361 6.1197-14.045 0.02622v-15.342",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.904 0.57052v24.384l17.904-0.03036v-6.1923l6.4958-0.01102-0.0161-18.192z",
    fill: "#fff",
    stroke: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m81.783 2.6025 20.616-0.04355-0.0228 2.5104h-20.624v2.6684h20.625v2.6113h-20.667v2.6273h13.276",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5712
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallFollowNavigatorIcon);
export default __webpack_public_path__ + "static/media/WallFollowNavigatorIcon.89ca449565c381a574b280ea9abb54fd.svg";
export { ForwardRef as ReactComponent };